const router = require("services/router");

function Field({label, error, errorMessage, className, children, tag, required, tooltip, description, format}) {
	let errorMarkup;

	if (typeof errorMessage === "string") {
		errorMarkup = (<p className="error">{errorMessage}</p>);
	}
	else if (typeof error === "string") {
		errorMarkup = (<p className="error">{error}</p>);
	}

	const requiredMarkup = required ? (<span>*</span>) : null;

	let classList = ["field"];

	if (typeof className === "string") {
		classList.push(className);
	}

	if (error) {
		classList.push("has-error");
	}

	if (tooltip) {
		tooltip = (
			<label className="tooltip"><img src={router.url('img/icons/info.svg')} alt="tooltip"/>
				<span className="tooltiptext">{tooltip}</span>
			</label>
		);
	}

	if (description) {
		description = (<p className="field-description">{description}</p>);
	}

	if (format) {
		format = (<p className="field-format">{format}</p>);
	}

	const Tag = tag || "label";

	return (
		<Tag className={classList.join(" ")}>
			<p className="label">{label}{requiredMarkup}{tooltip}</p>
			{description}
			<div className="field-inner">
				{children}
				{format}
			</div>
			{errorMarkup}
		</Tag>
	);
}

module.exports = Field;


// WEBPACK FOOTER //
// ./resources/js/components/forms/Field.js